module.exports = __webpack_public_path__ + "static/media/icContact_white.abbd4035.svg";